export enum EReplicationStyle {
	mainOnly = "main_only",
	allDocs = "all_docs"
}
